// extracted by mini-css-extract-plugin
module.exports = {"component":"comma-separated-list_component__oNfIq","itemsContainer":"comma-separated-list_itemsContainer___r08n"};